var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.showNoSprayMarkersForSprayPaths)+"\n  "+_vm._s(_vm.showSprayReminderMarkersForSprayPaths)+"\n  "+_vm._s(_vm.fade)+"\n  "+_vm._s(_vm.mappable.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }